import Cookie from 'js-cookie';
// 用于提供给业务方获取用户id
export const getUserId = () => {
    const userToken = Cookie.get('userToken');
    if (userToken) {
        return userToken.split('-')?.[1];
    }
};
